import { useQuery } from '@tanstack/react-query';
import { validateOrderByQR } from '../../infra/api';

export default function useValidateOrderByQR({ idOrder }) {
  return useQuery({
    queryKey: ['validate-order-by-qr', idOrder],
    queryFn: () => validateOrderByQR(idOrder),
    enabled: !!idOrder,
    retry: 0,
  });
}
